import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { I18nService } from '../core/i18n.service';

@Component({
  selector: 'app-information-page',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="page">
      <header class="card hero">
        <h1>{{ t('information.title') }}</h1>
        <p>{{ t('information.subtitle') }}</p>
      </header>

      <section class="card">
        <h2>{{ t('information.vision') }}</h2>
        <p>{{ t('information.visionText') }}</p>
      </section>

      <section class="card grid">
        <article>
          <h3>{{ t('information.structured') }}</h3>
          <p>{{ t('information.structuredText') }}</p>
        </article>
        <article>
          <h3>{{ t('information.verified') }}</h3>
          <p>{{ t('information.verifiedText') }}</p>
        </article>
        <article>
          <h3>{{ t('information.playerExp') }}</h3>
          <p>{{ t('information.playerExpText') }}</p>
        </article>
      </section>

      <section class="card note">
        <h2>{{ t('information.note') }}</h2>
        <p>{{ t('information.noteText') }}</p>
      </section>
    </section>
  `,
  styles: `
    .page { padding: 1.2rem; max-width: 980px; margin: 0 auto; display: grid; gap: 0.8rem; }
    .card { border: 1px solid var(--line-soft); border-radius: 12px; background: linear-gradient(180deg, rgba(23, 36, 58, 0.94) 0%, rgba(18, 29, 47, 0.94) 100%); padding: 1rem; box-shadow: var(--shadow-soft); }
    .hero h1 { margin: 0 0 0.35rem; color: var(--text-strong); font-size: 1.6rem; }
    .hero p { margin: 0; color: var(--text-muted); }
    h2 { margin: 0 0 0.4rem; color: var(--text-strong); font-size: 1.18rem; }
    h3 { margin: 0 0 0.35rem; color: #dce9ff; font-size: 1.02rem; }
    p { margin: 0; color: var(--text-muted); line-height: 1.5; }
    .grid { display: grid; gap: 0.75rem; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }
    .grid article { border: 1px solid rgba(106, 162, 255, 0.24); border-radius: 10px; padding: 0.75rem; background: rgba(15, 24, 40, 0.65); }
    .note { border-color: rgba(178, 145, 255, 0.35); background: linear-gradient(180deg, rgba(37, 27, 59, 0.72) 0%, rgba(21, 20, 44, 0.72) 100%); }
  `
})
export class InformationPageComponent {
  private readonly i18n = inject(I18nService);

  protected t(key: string, params?: Record<string, string | number | null | undefined>): string {
    return this.i18n.t(key, params);
  }
}
